














import { Vue, Component, Prop, Emit, Watch} from 'vue-property-decorator'
import TranscoProvidersDataTable from '../components/TranscoProvidersDataTable/TranscoProvidersDataTable.vue'
import store from '@/store'

@Component< TranscoProviders > ({
  components: {
    'transco-providers-data-table': TranscoProvidersDataTable,
  },
})
export default class TranscoProviders extends Vue {

  private transcoHyperProxiDataSortBy: any

  get transcoHyperProxiData() {
    return store.getters['transcoHyperProxi/getAll']
  }

  public constructor() {
    super()
    this.transcoHyperProxiDataSortBy = ['updateDate']
  }

}
